import styled from 'styled-components';
import Button from 'design-system/src/components/Button/Button';

const StyledSaveButton = styled(Button)`
  height: 32px;
`;

export type SaveFiltersButtonProps = {
  /**
   * Class name for additional styling; used to pass down styles when using inheritance in styled components
   */
  className?: string;
  /**
   * Whether to show the save filters button
   */
  $visible: boolean;
  /**
   * Callback function when the save filters button is clicked
   */
  onClick: () => void;
};

/**
 * A reusable save filters button component used across partner portal table components.
 * This component provides consistent styling and behavior for saving filter preferences.
 */
export const SaveFiltersButton = ({ className, $visible, onClick }: SaveFiltersButtonProps) => {
  if (!$visible) {
    return null;
  }

  return (
    <StyledSaveButton className={className} size="sm" variant="secondary" onClick={onClick}>
      Save filters
    </StyledSaveButton>
  );
};

export default SaveFiltersButton;
